// extracted by mini-css-extract-plugin
module.exports = {"formButtonsContainer":"styles-module__formButtonsContainer___3XjAn","formButton":"styles-module__formButton___3ebqZ"};